import {Column, Row} from "tabloom"
import {digg, digs} from "diggerize"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, View} from "shared/base"
import calculateAverageMood from "./calculate-average-mood"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import mergeStyles from "@kaspernj/api-maker/build/merge-styles"
import {Pressable} from "react-native"
import React from "react"
import {School} from "models"
import SchoolClassRow from "./school-class-row"
import {styles} from "../class-status-route"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

export default memo(shapeComponent(class RoutesUserClassStatusClassStepRow extends ShapeComponent {
  static propTypes = propTypesExact({
    classStepData: PropTypes.object.isRequired,
    classStatusRoute: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    lastRow: PropTypes.bool.isRequired,
    school: PropTypes.instanceOf(School).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.class_status.class_step_row"})

    this.expandIdentifier = `school-${this.p.school.id()}-class-step-${this.p.classStepData.classStepId}`
    this.setInstance({t})
    this.useStates({
      expanded: () => {
        const savedExpanded = this.p.classStatusRoute.s.expanded[this.tt.expandIdentifier]

        if (savedExpanded === true || savedExpanded === false) {
          return savedExpanded
        }

        return true
      }
    })
  }

  render() {
    const {t} = this.tt
    const {classStepData, lastRow} = this.p
    const {expanded} = this.s
    const {classStep, latestMoods, moods} = digs(classStepData, "classStep", "latestMoods", "moods")
    const schoolClassesDatas = Object.values(classStepData.schoolClasses)

    return (
      <>
        <Row
          dataSet={this.cache("rowDataSet", {
            classStepId: classStep?.id() || "no-class-step",
            expanded
          }, [classStep?.id(), expanded])}
          style={this.cache("rowStyle", {
            backgroundColor: "#e5dfff",
            borderColor: "#e5dfff",
            borderBottomWidth: lastRow ? 1 : 0,
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderStyle: "solid",
            borderBottomLeftRadius: lastRow && !expanded ? 24 : 0,
            borderBottomRightRadius: lastRow && !expanded ? 24 : 0
          }, [expanded, lastRow])}
          testID="routes/user/class-status/class-step-row"
        >
          <Column style={this.nameColumnStyle ||= {flexDirection: "row", alignItems: "center", paddingLeft: 8}}>
            <View
              style={this.cache("nameColumnViewContainerStyle", {
                alignItems: "center",
                flexDirection: "row",
                width: "100%",
                height: "100%",
                padding: 18,
                backgroundColor: "#fff",
                borderBottomLeftRadius: lastRow && !expanded ? 24 : 0
              }, [expanded, lastRow])}
            >
              <Pressable onPress={this.tt.onExpandPress} style={{marginRight: 4}} testID="expand-button">
                <Icon name={expanded ? "chevron-up" : "chevron-down"} style={styles.columnText} />
              </Pressable>
              <Text style={mergeStyles([styles.columnText, {fontWeight: "bold"}])}>
                {classStep ? classStep.name() : t(".no_class_step")}
              </Text>
            </View>
          </Column>
          <Column style={this.nicknameColumnStyle ||= {padding: 18, backgroundColor: "#fff"}} />
          <Column style={this.teachersColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
            <Text style={styles.columnText}>{Object.keys(classStepData.teachers).length}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}}>
            <Text style={styles.columnText}>{digg(classStepData, "topPositiveScoreFactor")?.name()}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}}>
            <Text style={styles.columnText}>{digg(classStepData, "topNegativeScoreFactor")?.name()}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}}>
            <Text style={styles.columnText}>{moods && calculateAverageMood(moods)}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}}>
            <Text style={styles.columnText}>{latestMoods?.length > 0 && calculateAverageMood(latestMoods)}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}} testID="check-ins-column">
            <Text style={styles.columnText}>{digg(classStepData, "checkInsCount")}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}} testID="brain-breaks-column">
            <Text style={styles.columnText}>{digg(classStepData, "brainBreaksCount")}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}} testID="challenges-column">
            <Text style={styles.columnText}>{digg(classStepData, "challengesCount")}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}}>
            <Text style={styles.columnText}>{digg(classStepData, "unicornEffectsCount")}</Text>
          </Column>
          <Column style={{padding: 18, backgroundColor: "#fff"}}>
            <Text style={styles.columnText}>{digg(classStepData, "activeCourses")}</Text>
          </Column>
          <Column style={this.actionsColumnStyle ||= {padding: 18, backgroundColor: "#fff"}} />
        </Row>
        {expanded && schoolClassesDatas.map((schoolClassData, schoolClassIndex) =>
          <SchoolClassRow
            key={schoolClassData.schoolClass.id()}
            lastRow={lastRow && (schoolClassIndex + 1) == schoolClassesDatas.length}
            schoolClassData={schoolClassData}
          />
        )}
      </>
    )
  }

  onExpandPress = () => {
    const classStepId = digg(this.p.classStepData, "classStepId")

    this.setState({expanded: !this.s.expanded})
    this.p.classStatusRoute.updateExpanded({expanded: this.s.expanded, identifier: this.tt.expandIdentifier, modelClass: "ClassStep", modelId: classStepId})
  }
}))
